<template>
  <div class="page-wrapper">
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input
              placeholder="请输入企业名称"
              v-model="searchForm.companyName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.status"
              clearable
              placeholder="请选择企业状态"
            >
              <el-option label="未完善" :value="0"></el-option>
              <el-option label="未评级" :value="1"></el-option>
              <el-option label="已评级" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="right">
          <el-button type="primary">新增</el-button>
      </div> -->
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="企业照片">
          <template slot-scope="scope">
            <img style="width: 64px; height: 64px; object-fit: cover; " :src="scope.row.photoUrls[0]" alt="">
          </template>
        </el-table-column>
        <el-table-column label="企业名称">
          <template slot-scope="scope">
            {{scope.row.companyName}}
          </template>
        </el-table-column>
        <el-table-column label="业务类型">
          <template slot-scope="scope">
            {{scope.row.businessTypesStr}}
          </template>
        </el-table-column>
        <el-table-column label="评级结果">
          <template slot-scope="scope">
            {{scope.row.userRating ? scope.row.userRating : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="openDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              type="primary"
              plain
              size="mini"
              @click="openGrade(scope)"
              >评级</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>

    <el-dialog
      title="企业信息"
      :visible.sync="detailVisible"
      width="800px"
    >
      <div class="detail-wrap">
        <el-row :gutter="16">
          <el-col :span="24">
            <div class="line">
              <span class="label">企业名称：</span>
              <span class="value">{{detailData.companyName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <div class="line">
              <span class="label">公司地址：</span>
              <span class="value">{{detailData.detailAdress}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">联系人员：</span>
              <span class="value">{{detailData.contacts}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">联系电话：</span>
              <span class="value">{{detailData.contactNumber}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <div class="line">
              <span class="label">业务类型：</span>
              <span class="value">{{detailData.businessTypesStr}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">评级结果：</span>
              <span class="value">{{detailData.userRating ? detailData.userRating : '-'}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <div class="line">
              <span class="label">展厅空间：</span>
              <span class="value">
                <img class="img" v-for="url in detailData.photoUrls" :key="url" :src="url"
                  @click="viewBigImg(url)"
                >
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">创建时间：</span>
              <span class="value">{{detailData.createTime}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">更新时间：</span>
              <span class="value">{{detailData.updateTime}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      title="企业评级"
      :visible.sync="gradeVisible"
      :close-on-click-modal="false"
      width="600px"
    > 
      <div style="padding: 40px 0 16px">
        <el-form :model="gradeForm" :rules="gradeRules" ref="gradeForm" label-width="160px">
          <el-form-item label="评级结果：" prop="userRating">
            <el-radio-group v-model="gradeForm.userRating">
              <el-radio label="S"></el-radio>
              <el-radio label="A"></el-radio>
              <el-radio label="B"></el-radio>
              <el-radio label="C"></el-radio>
              <el-radio label="D"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="gradeVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitGradeForm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="查看大图"
      :visible.sync="imgVisible"
      width="800px"
    >
      <img style="width: 100%" :src="imgPath" alt="大图">
    </el-dialog>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { api, request } from "@/common/request_talent.js";
import { buildThumborUrl } from '@/common/tool.js'
import { Loading } from 'element-ui';
export default {
  name: "companyList",
  data() {
    return {
      isLoading: false,
      searchForm: {
        companyName: '',
        status: '',
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      //表格
      tableData: [],
      detailVisible: false,
      detailData: {},
      gradeVisible: false,
      gradeForm: {
        userRating: ''
      },
      gradeRules: {
        userRating: [
          { required: true, message: '请选择级别', trigger: 'change' }
        ],
      },
      rowIndex: null,

      // 查看大图
      imgVisible: false,
      imgPath: ''
    };
  },
  computed: {
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        let query = route.query
        this.pagination.size = Number(query.size)
          ? Number(query.size)
          : 10;
        this.pagination.current = Number(query.current)
          ? Number(query.current)
          : 1;
        this.searchForm.companyName = query.companyName 
          ? query.companyName
          : ''
        this.searchForm.status = query.status 
          ? Number(query.status)
          : ''
        this.getCompanyList();
      },
      immediate: true,
    },
  },
  methods: {
    viewBigImg(url) {
      this.imgPath = url
      this.imgVisible = true
    },
    getCompanyList() {
      this.isLoading = true;
      let params =  {
        current: this.pagination.current,
        size: this.pagination.size,
      }
      let companyName = this.searchForm.companyName.trim()
      if (companyName !== '') params.companyName = companyName

      let status = this.searchForm.status
      if (status !== '') params.status = +status
      
      request({
        url: api.baseUrl + "/company_information/page",
        method: "get",
        params: params,
      })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.pagination.total = parseInt(res.data.total);
            this.tableData = res.data.records.map(item => {
              let detailAdress = item.companyProvinceName + ' '
                + item.companyCityName + ' ' 
                + item.companyDistrictName + ' '
                + item.companyAddress
              return {
                ...item,
                businessTypesStr: item.businessTypes.join('、'),
                detailAdress,
                photoUrls: item.displaySpace.map(url => buildThumborUrl(url))
              }
            });
          } else {
            this.$message.error(res.msg || "获取列表信息失败");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openDetail(row) {
      this.detailData = row
      this.detailVisible = true
    },
    openGrade(scope) {
      console.log(scope)
      this.detailData = scope.row
      this.rowIndex = scope.$index
      this.gradeForm.userRating = this.detailData.userRating || ''
      this.gradeVisible = true
    },
    submitGradeForm() {
      console.log(this.gradeForm)
      this.$refs['gradeForm'].validate((valid) => {
        if (valid) {
          console.log('submit!');
          this.gradeUser()
        }
      });
    },
    gradeUser() {
      let loadingInstance = Loading.service({
        text: '正在提交...'
      });
      request({
        url: api.baseUrl + "/talent-transaction-user-info/platformRatingOfUser",
        method: "post",
        data: {
          adminId: this.adminId,
          userId: this.detailData.userId,
          userRating: this.gradeForm.userRating
        }
      })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.tableData[this.rowIndex].userRating = this.gradeForm.userRating
            this.gradeVisible = false
            this.$refs['gradeForm'].resetFields();
            this.$message.success('提交成功')
          } else {
            this.$message.error(res.msg || "网络错误");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
    searchHandle() {
      console.log(this.searchForm);
      console.log("searchHandle");
      this.pagination.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      let str = "?current=" +
        this.pagination.current +
        "&size=" +
        this.pagination.size

      if (this.searchForm.companyName) {
        str += "&companyName=" + this.searchForm.companyName.trim()
      }

      if (this.searchForm.status !== '') {
        str += "&status=" + this.searchForm.status
      }

      str += '&r=' + new Date().getTime()

      this.$router.push(
        "/company/list" + str
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.pagination.size = size;
      this.pagination.current = 1;
      this.updateRouter();
    },
    handleCurrentChange(current) {
      //分页：改变第n页
      this.pagination.current = current;
      this.updateRouter();
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
}
.searchBox {
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 16px 0;
}
.detail-wrap {
  padding: 16px 16px 64px;
  .line { padding: 16px 0; display: flex;}
  .label {width: 72px; text-align: right; padding-right: 8px; color: #666; flex-shrink: 0; font-size: 13px;}
  .value {color: #000; font-size: 13px;}
  .img {width: 64px; height: 64px; object-fit: cover; margin-right: 8px;}
}

</style>



// WEBPACK FOOTER //
// src/pages/company/list.vue